import { useMutation, useQuery, useQueryClient } from 'react-query';
import axios from 'axios';
import { INDEX_PAGE } from './useInvoices'; // item 1480 — whole index, not a 100-row page
import { ProposalsDto } from '../models/proposal';

const apiUrl = process.env.REACT_APP_BASIX_API || '';

const getArchived = async (): Promise<ProposalsDto> => {
  const { data } = await axios.get(`${apiUrl}proposal/Archived`, { params: { pageSize: INDEX_PAGE } });
  return data;
};

// item 485 — the archived-proposals area (Chad: archive moves a proposal OUT of the main
// list into its own view; void stays in the list, badged). Mirrors useItemArchive. Restore
// is moderator-gated server-side.
const useProposalsArchived = (enabled = true) => {
  const queryClient = useQueryClient();
  const query = useQuery('proposalsArchived', getArchived, { enabled });

  const invalidateAll = () => {
    queryClient.invalidateQueries('proposalsArchived');
    queryClient.invalidateQueries('proposals');
    queryClient.invalidateQueries('project');
  };
  const restoreMutation = useMutation(
    (id: string) => axios.post(`${apiUrl}proposal/RestoreProposal/${id}`),
    { onSuccess: invalidateAll },
  );
  // dart (2026-07-16, Chad) — one-click FULL restore: un-archive AND un-void in a single call
  const fullyRestoreMutation = useMutation(
    (id: string) => axios.post(`${apiUrl}proposal/FullyRestoreProposal/${id}`),
    { onSuccess: invalidateAll },
  );

  return {
    archived: query.data?.index ?? [],
    isLoadingArchived: query.isLoading,
    restore: restoreMutation.mutateAsync,
    isRestoring: restoreMutation.isLoading,
    // the id currently restoring, for a per-row spinner
    restoringId: restoreMutation.isLoading ? (restoreMutation.variables ?? null) : null,
    fullyRestore: fullyRestoreMutation.mutateAsync,
    fullyRestoringId: fullyRestoreMutation.isLoading ? (fullyRestoreMutation.variables ?? null) : null,
  };
};

export default useProposalsArchived;
